import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {pluralize} from 'BenchlingUtil';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface ReviewLifecycleUpdateConfirmationModalProps {
  reviewLifecycleName: string;
  numObjectsUsingReviewLifecycle: number;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function ReviewLifecycleUpdateConfirmationModal({
  reviewLifecycleName,
  numObjectsUsingReviewLifecycle,
  onRequestClose,
  onRequestSubmit,
}: ReviewLifecycleUpdateConfirmationModalProps): JSX.Element {
  return (
    <Modal
      closeable={true}
      title="Update review process"
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      buttons={[
        {
          text: 'Cancel Update',
          cancel: true,
          style: ButtonStyle.TERTIARY_GRAY,
        },
        {
          text: 'Confirm Update',
          submit: true,
          style: ButtonStyle.NEGATIVE,
        },
      ]}
    >
      <p>
        Are you sure you want to update <b>{reviewLifecycleName}</b>? There
        {` ${pluralize(numObjectsUsingReviewLifecycle, 'is', 'are')} `}
        <b>{numObjectsUsingReviewLifecycle}</b> {pluralize(numObjectsUsingReviewLifecycle, 'item')} (projects
        and template collections) associated with it.
        {BenchlingConfig.ENABLE_RETRACT_ACTIVE_REVIEWS_ON_REVIEW_PROCESS_UPDATE ? (
          <>
            &nbsp;Items in projects that are currently <b>In Review</b> will be reset to <b>In Progress</b>{' '}
            and must be re-sent for review.
          </>
        ) : (
          <>
            &nbsp;Items in projects that are sent for review after this update will be using the updated
            Review Process. Items in projects that are currently in review won't be affected.
          </>
        )}
        {/* Template collections always retract; the retract config only governs projects. */}
        &nbsp;Items in template collections that are <b>In Review</b> or <b>Accepted</b> will be reset to{' '}
        <b>In Progress</b> and must be re-sent for review.
      </p>
    </Modal>
  );
}
